import React, { useEffect, useContext, useState, Fragment } from 'react'
import { ContentBodyContext } from '../MainContent';

function Workunit() {
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const initialState = {
        workunitName: 'undefined',
        workunitAcronym: 'NA'
    }
    const [renderWorkunit, setrenderWorkunit] = useState(initialState)
    useEffect(() => {
        setrenderWorkunit({
            ...renderWorkunit,
            workunitName: stateContentBody.workunitName,
            workunitAcronym: stateContentBody.workunitAcronym
        })
    }, [stateContentBody.workunitName])
    return (
        <div className="col-lg-4 col-md-6 col-sm-6 col-12">
            <div className="card card-statistic-1">
                <div className="card-icon bg-danger">
                    <i className="far fa-building" style={{ fontSize: '35px' }}></i>
                </div>
                <div className="card-wrap">
                    <div className="card-header">
                        <h4>Workunit</h4>
                    </div>
                    <div className="card-body">
                        {`${renderWorkunit.workunitName} (${renderWorkunit.workunitAcronym}) `}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Workunit
